import React, { FC } from "react";
import {
  EventDataMessageType,
  MessageTypes,
  QuickReplyType,
} from "@app/pippa/models";
import classNames from "classnames";
import {
  TextMessage,
  AvatarLogo,
  QuickReply,
  MessageFeedback,
} from "@app/pippa/components/message";
import AIAssistant from "@app/pippa/assets/ai-assistant.png";

interface MessageTypesProps {
  message: EventDataMessageType;
  isShowAvatar: boolean;
  isLastMessage: boolean;
}

interface MessageTypesAliasKeys {
  [key: string]: FC<MessageTypesProps>;
}

const MessageType = {
  [MessageTypes.TEXT]: TextMessage,
} as MessageTypesAliasKeys;

interface Props {
  message: EventDataMessageType;
  messageIndex: number;
  isShowLogo: boolean;
  isLastMessage: boolean;
  showTyping: boolean;
}

const MessageBody: FC<Props> = ({
  message,
  messageIndex,
  isShowLogo,
  isLastMessage,
  showTyping,
}) => {
  const isShowAvatar = isShowLogo;
  const CurrentMessage = MessageType[message.type];

  const messageBodyClassNames = classNames("message-body__container", {
    "message-body__without-logo": !isShowAvatar,
    "send-by-user": message.isSendByUser,
    "first-message": messageIndex === 0,
  });

  const shouldShowReply = (
    message: EventDataMessageType,
    isLastMessage: boolean
  ): boolean => {
    return Boolean(isLastMessage && message.quickReplies && !showTyping);
  };

  // `feedbackEligible` only ever arrives from the backend in the same tail of the SSE
  // stream that carries the real `message_id`, so gating on it also guarantees
  // `message.id` is a server id rather than the client-side uuid from `onStart`.
  const showFeedback =
    !message.isSendByUser &&
    !message.isError &&
    Boolean(message.feedbackEligible) &&
    Boolean(message.text) &&
    !message.feedback;

  return (
    <div className={messageBodyClassNames}>
      {isShowAvatar && <AvatarLogo logoSrc={AIAssistant} />}
      <CurrentMessage
        message={message}
        isShowAvatar={isShowAvatar}
        isLastMessage={isLastMessage}
      />
      {showFeedback && (
        <MessageFeedback messageId={message.id} reaction={message.reaction} />
      )}
      {shouldShowReply(message, isLastMessage) && (
        <QuickReply
          replies={(message.quickReplies as QuickReplyType[]) || []}
        />
      )}
    </div>
  );
};

export default MessageBody;
